export const BUTTON_STYLES = {
    modalSecondary: {
        onlyText: true,
        type: "button",
        width: "80px",
        height: "32px",
        bgColor: "var(--color-Button4)",
        hoverBgColor: "var(--color-ButtonHover4)",
        fontColor: "var(--color-Black)",
        fontWeight: "400",
    },
    modalPrimary: {
        onlyText: true,
        type: "button",
        width: "80px",
        height: "32px",
        bgColor: "var(--color-Button1)",
        hoverBgColor: "var(--color-ButtonHover1)",
        fontColor: "var(--color-White)",
    },
    paginationIcon: {
        onlyIcon: true,
        type: "button",
        bgColor: "transparent",
        hoverBgColor: "var(--color-ButtonHover4)",
        transparentDisabled: true,
    },
    paginationNumber: {
        onlyText: true,
        type: "button",
        margin: "0 4px",
        height: "24px",
        width: "auto",
        minWidth: "24px",
    },
};
